import React from 'react'
import { NavLink } from 'react-router-dom';

export default function Home() {
	return (
		<main className="pt-20 lg:pt-10 px-1 pb-20 2xl:px-10">
			<div>
				<h1 className="mb-10">Introduction</h1>
				<div className="w-100 h-[1px] bg-gray-400" />
			</div>
			<div className="flex space-x-2 mt-10 bg-[#f3f8f3] p-2 pl-5 border-l-2 border-[#489e49]">
				<div>👍</div>
				<div>
					<div>
						<h2 className="text-lg font-bold text-[#489e49]">
							Make Simple, Seamless, and Secure Payments.
						</h2>
					</div>
					<div>
						<p className="text-[#384248]">
							Making payments online or offline, anytime, anywhere globally,
							shouldn&apos;t be hard. We make it easier
						</p>
					</div>
				</div>
			</div>
			<div className="mt-10">
				<h4>
					We help you focus on the end-to-end payment that meets your business
					cash flow needs, so you can focus on what matters most to your
					customers. Our cutting edge hinged on a simple, secure, and seamless
					platform that works across different devices.
				</h4>
			</div>

			<div className="flex justify-center">
				<img
					src={require('../../assets/overview.png')}
					alt="overview"
					className="w-full self-center"
					width={628}
					height={308}
				/>
			</div>

			<div className="mt-10 text-[12px]">WHAT&apos;S NEXT</div>
			<div>
				<NavLink to="/merchant-registration">
					<div className="inline-flex items-center space-x-2">
						<h3 className="text-[#083d8c] text-[16px]">
							Merchant Registration
						</h3>
						<svg
							xmlns="http://www.w3.org/2000/svg"
							fill="none"
							viewBox="0 0 24 24"
							strokeWidth={1.5}
							stroke="currentColor"
							className="w-6 h-6"
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3"
							/>
						</svg>
					</div>
				</NavLink>
			</div>
		</main>
	);
}
